<template>
    <div>
        <div class="banner">
            <div class="title">
                {{title}}
                <span class="title-en">{{titleEn}}</span>
            </div>

            <img class="bg" src="@/speaker/banner.png" alt="">
            <!--<img class="right-pic" src="@/speaker/right-pic.png" alt="">-->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Banner',
        props: ['title','titleEn']
    }
</script>

<style lang="scss" type="text/scss" scoped>

    .banner{
        position: relative;
        width: 100%;
        .bg{
            width: 100%;
            height: auto;
            display: block;
        }
        .right-pic{
            position: absolute;
            margin-right: .88rem;
            top: 40%;
            right: 0;
            width: 2.69rem;
            height: auto;
        }
        .title{
            position: absolute;
            padding-left: .94rem;
            left: 0;
            top: 47%;
            font-size: .2rem;
            font-weight: bold;
            color: #fff;
            z-index: 2;
            &:before{
                position: absolute;
                width: 2rem;
                height: 2px;
                background-color: #FFFFFF;
                content: '';
                left: -74%;
                top: .14rem;
            }
            span{
                display: block;
                font-size: .13rem;
                text-align: left;
                font-weight: lighter;
            }
        }
    }

</style>
